import React, { Suspense, useEffect, useState } from 'react';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import CookieBar from './components/CookieBar.jsx';

const Hero = React.lazy(() => import('./components/Hero.jsx'));
const PainPoints = React.lazy(() => import('./components/PainPoints.jsx'));
const Differentiators = React.lazy(() => import('./components/Differentiators.jsx'));
const HowItWorks = React.lazy(() => import('./components/HowItWorks.jsx'));
const Testimonials = React.lazy(() => import('./components/Testimonials.jsx'));
const Gallery = React.lazy(() => import('./components/Gallery.jsx'));
const Schedule = React.lazy(() => import('./components/Schedule.jsx'));
const Story = React.lazy(() => import('./components/Story.jsx'));
const Blog = React.lazy(() => import('./components/Blog.jsx'));
const FAQ = React.lazy(() => import('./components/FAQ.jsx'));
const FinalCTA = React.lazy(() => import('./components/FinalCTA.jsx'));

const App = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const current = window.pageYOffset;
      setScrollProgress(total > 0 ? current / total : 0);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white dark:bg-dark-950 text-dark-800 dark:text-dark-200">
      <Header />
      <div className="progress-bar" style={{ transform: `scaleX(${scrollProgress})` }} />
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          </div>
        }
      >
        <main>
          <Hero />
          <PainPoints />
          <Differentiators />
          <HowItWorks />
          <Testimonials />
          <Gallery />
          <Schedule />
          <Story />
          <Blog />
          <FAQ />
          <FinalCTA />
        </main>
      </Suspense>
      <CookieBar />
      <Footer />
    </div>
  );
};

export default App;
